// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see InstrumentLinkInitiateEvent
 */
export var InstrumentLinkInitiate = function (_a) {
    var currentLinked = _a.currentLinked;
    return ({
        name: "Instrument Link Initiate",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Link",
            current_linked: currentLinked !== undefined && currentLinked !== null ? currentLinked.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentLinkAuthenticateInstitutionEvent
 */
export var InstrumentLinkAuthenticateInstitution = function (_a) {
    var clientScenario = _a.clientScenario, failureReason = _a.failureReason, flowToken = _a.flowToken, flowType = _a.flowType, institutionId = _a.institutionId, institutionName = _a.institutionName, linkEventName = _a.linkEventName, networkError = _a.networkError, ratePlan = _a.ratePlan, responseCode = _a.responseCode, source = _a.source, status = _a.status;
    return ({
        name: "Instrument Link AuthenticateInstitution",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Link",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            failure_reason: failureReason !== undefined && failureReason !== null ? failureReason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_type: flowType !== undefined && flowType !== null ? flowType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            institution_id: institutionId !== undefined && institutionId !== null ? institutionId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            institution_name: institutionName !== undefined && institutionName !== null ? institutionName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            link_event_name: linkEventName !== undefined && linkEventName !== null ? linkEventName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            network_error: networkError !== undefined && networkError !== null ? networkError.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            rate_plan: ratePlan !== undefined && ratePlan !== null ? ratePlan.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            response_code: responseCode !== undefined && responseCode !== null ? responseCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            status: status !== undefined && status !== null ? status.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentLinkGetProfileSyncEvent
 */
export var InstrumentLinkGetProfileSync = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken, attempts = _a.attempts, durationMs = _a.durationMs, successful = _a.successful;
    return ({
        name: "Instrument Link GetProfileSync",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Link",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            attempts: attempts !== undefined && attempts !== null ? attempts.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            duration_ms: durationMs !== undefined && durationMs !== null ? durationMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            successful: successful !== undefined && successful !== null ? successful.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentLinkBrowseSecurityInfoEvent
 */
export var InstrumentLinkBrowseSecurityInfo = function (_a) {
    var entryPoint = _a.entryPoint, treatment = _a.treatment, value = _a.value, variant = _a.variant;
    return ({
        name: "Instrument Link BrowseSecurityInfo",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Link",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            value: value !== undefined && value !== null ? value.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentLinkNavigateEvent
 */
export var InstrumentLinkNavigate = function (_a) {
    var clientScenario = _a.clientScenario, entryPoint = _a.entryPoint, flowToken = _a.flowToken, ratePlan = _a.ratePlan, source = _a.source, treatment = _a.treatment, value = _a.value, variant = _a.variant;
    return ({
        name: "Instrument Link Navigate",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Link",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            rate_plan: ratePlan !== undefined && ratePlan !== null ? ratePlan.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            value: value !== undefined && value !== null ? value.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentLinkReceiveLinkResultEvent
 */
export var InstrumentLinkReceiveLinkResult = function (_a) {
    var entryPoint = _a.entryPoint, result = _a.result, treatment = _a.treatment, variant = _a.variant;
    return ({
        name: "Instrument Link ReceiveLinkResult",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Link",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            result: result !== undefined && result !== null ? result.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentLinkSubmitLinkEvent
 */
export var InstrumentLinkSubmitLink = function (_a) {
    var result = _a.result, treatment = _a.treatment, variant = _a.variant;
    return ({
        name: "Instrument Link SubmitLink",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Link",
            result: result !== undefined && result !== null ? result.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentLinkRetryEvent
 */
export var InstrumentLinkRetry = function (_a) {
    var entryPoint = _a.entryPoint, treatment = _a.treatment, variant = _a.variant;
    return ({
        name: "Instrument Link Retry",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Link",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentLinkStartEvent
 */
export var InstrumentLinkStart = function (_a) {
    var clientScenario = _a.clientScenario, entryPoint = _a.entryPoint, flowToken = _a.flowToken, prePopulatedFromScan = _a.prePopulatedFromScan, ratePlan = _a.ratePlan, source = _a.source, treatment = _a.treatment, type = _a.type, variant = _a.variant, linkAction = _a.linkAction;
    return ({
        name: "Instrument Link Start",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Link",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            pre_populated_from_scan: prePopulatedFromScan !== undefined && prePopulatedFromScan !== null ? prePopulatedFromScan.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            rate_plan: ratePlan !== undefined && ratePlan !== null ? ratePlan.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            link_action: linkAction !== undefined && linkAction !== null ? linkAction.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentLinkRemoveEvent
 */
export var InstrumentLinkRemove = function (_a) {
    var token = _a.token, type = _a.type;
    return ({
        name: "Instrument Link Remove",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Link",
            token: token !== undefined && token !== null ? token.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentLinkReplaceEvent
 */
export var InstrumentLinkReplace = function (_a) {
    var token = _a.token, type = _a.type;
    return ({
        name: "Instrument Link Replace",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Link",
            token: token !== undefined && token !== null ? token.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentLinkViewSecurityInfoEvent
 */
export var InstrumentLinkViewSecurityInfo = function (_a) {
    var entryPoint = _a.entryPoint, treatment = _a.treatment, variant = _a.variant;
    return ({
        name: "Instrument Link ViewSecurityInfo",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Link",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentLinkCompleteEvent
 */
export var InstrumentLinkComplete = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken, ratePlan = _a.ratePlan, source = _a.source;
    return ({
        name: "Instrument Link Complete",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Link",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            rate_plan: ratePlan !== undefined && ratePlan !== null ? ratePlan.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentLinkReceiveErrorEvent
 */
export var InstrumentLinkReceiveError = function (_a) {
    var clientScenario = _a.clientScenario, failureField = _a.failureField, flowToken = _a.flowToken, instrumentMismatch = _a.instrumentMismatch, message = _a.message, networkError = _a.networkError, ratePlan = _a.ratePlan, responseCode = _a.responseCode, source = _a.source;
    return ({
        name: "Instrument Link ReceiveError",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Link",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            failure_field: failureField !== undefined && failureField !== null ? failureField.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            instrument_mismatch: instrumentMismatch !== undefined && instrumentMismatch !== null ? instrumentMismatch.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            message: message !== undefined && message !== null ? message.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            network_error: networkError !== undefined && networkError !== null ? networkError.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            rate_plan: ratePlan !== undefined && ratePlan !== null ? ratePlan.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            response_code: responseCode !== undefined && responseCode !== null ? responseCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentScanCheckCameraPermissionStatusEvent
 */
export var InstrumentScanCheckCameraPermissionStatus = function (_a) {
    var androidCameraPermissionStatus = _a.androidCameraPermissionStatus, iosCameraPermissionStatus = _a.iosCameraPermissionStatus, entryPoint = _a.entryPoint, treatment = _a.treatment, variant = _a.variant;
    return ({
        name: "Instrument Scan CheckCameraPermissionStatus",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Scan",
            android_camera_permission_status: androidCameraPermissionStatus !== undefined && androidCameraPermissionStatus !== null ? androidCameraPermissionStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ios_camera_permission_status: iosCameraPermissionStatus !== undefined && iosCameraPermissionStatus !== null ? iosCameraPermissionStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentScanManageCameraAccessMessageEvent
 */
export var InstrumentScanManageCameraAccessMessage = function (_a) {
    var entryPoint = _a.entryPoint, option = _a.option, treatment = _a.treatment, variant = _a.variant;
    return ({
        name: "Instrument Scan ManageCameraAccessMessage",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Scan",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            option: option !== undefined && option !== null ? option.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentScanManageCameraAccessPromptEvent
 */
export var InstrumentScanManageCameraAccessPrompt = function (_a) {
    var enabled = _a.enabled, entryPoint = _a.entryPoint, treatment = _a.treatment, variant = _a.variant;
    return ({
        name: "Instrument Scan ManageCameraAccessPrompt",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Scan",
            enabled: enabled !== undefined && enabled !== null ? enabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentScanMessageCameraAccessSettingsEvent
 */
export var InstrumentScanMessageCameraAccessSettings = function (_a) {
    var openSettings = _a.openSettings, entryPoint = _a.entryPoint, treatment = _a.treatment, variant = _a.variant;
    return ({
        name: "Instrument Scan MessageCameraAccessSettings",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Scan",
            open_settings: openSettings !== undefined && openSettings !== null ? openSettings.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentScanNavigateBackEvent
 */
export var InstrumentScanNavigateBack = function (_a) {
    var entryPoint = _a.entryPoint, treatment = _a.treatment, variant = _a.variant;
    return ({
        name: "Instrument Scan NavigateBack",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Scan",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentScanReceiveScanResultEvent
 */
export var InstrumentScanReceiveScanResult = function (_a) {
    var captureTimeMs = _a.captureTimeMs, entryPoint = _a.entryPoint, errorMessage = _a.errorMessage, result = _a.result, treatment = _a.treatment, variant = _a.variant;
    return ({
        name: "Instrument Scan ReceiveScanResult",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Scan",
            capture_time_ms: captureTimeMs !== undefined && captureTimeMs !== null ? captureTimeMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_message: errorMessage !== undefined && errorMessage !== null ? errorMessage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            result: result !== undefined && result !== null ? result.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentScanSwitchFlashlightEvent
 */
export var InstrumentScanSwitchFlashlight = function (_a) {
    var enabled = _a.enabled, entryPoint = _a.entryPoint, treatment = _a.treatment, variant = _a.variant;
    return ({
        name: "Instrument Scan SwitchFlashlight",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Scan",
            enabled: enabled !== undefined && enabled !== null ? enabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentScanTypeDetailsEvent
 */
export var InstrumentScanTypeDetails = function (_a) {
    var entryPoint = _a.entryPoint, treatment = _a.treatment, variant = _a.variant;
    return ({
        name: "Instrument Scan TypeDetails",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Scan",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentScanViewCameraAccessEvent
 */
export var InstrumentScanViewCameraAccess = function (_a) {
    var entryPoint = _a.entryPoint, treatment = _a.treatment, variant = _a.variant;
    return ({
        name: "Instrument Scan ViewCameraAccess",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Scan",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentScanViewCameraAccessMessageEvent
 */
export var InstrumentScanViewCameraAccessMessage = function (_a) {
    var entryPoint = _a.entryPoint, treatment = _a.treatment, variant = _a.variant;
    return ({
        name: "Instrument Scan ViewCameraAccessMessage",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Scan",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentScanViewCameraAccessSettingsEvent
 */
export var InstrumentScanViewCameraAccessSettings = function (_a) {
    var entryPoint = _a.entryPoint, treatment = _a.treatment, variant = _a.variant;
    return ({
        name: "Instrument Scan ViewCameraAccessSettings",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Scan",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentScanViewHelpEvent
 */
export var InstrumentScanViewHelp = function (_a) {
    var entryPoint = _a.entryPoint, option = _a.option, treatment = _a.treatment, variant = _a.variant;
    return ({
        name: "Instrument Scan ViewHelp",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Scan",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            option: option !== undefined && option !== null ? option.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentScanViewScanEvent
 */
export var InstrumentScanViewScan = function (_a) {
    var entryPoint = _a.entryPoint, treatment = _a.treatment, variant = _a.variant;
    return ({
        name: "Instrument Scan ViewScan",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Scan",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            treatment: treatment !== undefined && treatment !== null ? treatment.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant: variant !== undefined && variant !== null ? variant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentVerifyStartEvent
 */
export var InstrumentVerifyStart = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken, ratePlan = _a.ratePlan, source = _a.source;
    return ({
        name: "Instrument Verify Start",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Verify",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            rate_plan: ratePlan !== undefined && ratePlan !== null ? ratePlan.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentVerifyCompleteEvent
 */
export var InstrumentVerifyComplete = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken, ratePlan = _a.ratePlan, source = _a.source;
    return ({
        name: "Instrument Verify Complete",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Verify",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            rate_plan: ratePlan !== undefined && ratePlan !== null ? ratePlan.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentVerifyReceiveErrorEvent
 */
export var InstrumentVerifyReceiveError = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken, message = _a.message, networkError = _a.networkError, ratePlan = _a.ratePlan, responseCode = _a.responseCode, source = _a.source;
    return ({
        name: "Instrument Verify ReceiveError",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Verify",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            message: message !== undefined && message !== null ? message.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            network_error: networkError !== undefined && networkError !== null ? networkError.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            rate_plan: ratePlan !== undefined && ratePlan !== null ? ratePlan.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            response_code: responseCode !== undefined && responseCode !== null ? responseCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentAuthorizeAutoDismissEvent
 *
 * @deprecated Use `BlockerFlow.Interact.TriggerScheduledAction` instead.
 */
export var InstrumentAuthorizeAutoDismiss = function (_a) {
    var autoDismissDelayMs = _a.autoDismissDelayMs, blockerAction = _a.blockerAction;
    return ({
        name: "Instrument Authorize AutoDismiss",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Authorize",
            auto_dismiss_delay_ms: autoDismissDelayMs !== undefined && autoDismissDelayMs !== null ? autoDismissDelayMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            blocker_action: blockerAction !== undefined && blockerAction !== null ? blockerAction.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentAuthorizeOpenInTransactionTopUpEducationPageEvent
 *
 * @deprecated Use `DeclinePreventionBlocker.Interact.InfoClicked` instead.
 */
export var InstrumentAuthorizeOpenInTransactionTopUpEducationPage = function () { return ({
    name: "Instrument Authorize OpenInTransactionTopUpEducationPage",
    parameters: {
        cdf_entity: "Instrument",
        cdf_action: "Authorize",
    }
}); };
/**
 * @see InstrumentSelectTapOptionEvent
 */
export var InstrumentSelectTapOption = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken, action = _a.action, digitalWalletType = _a.digitalWalletType;
    return ({
        name: "Instrument Select TapOption",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Select",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            action: action !== undefined && action !== null ? action.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            digital_wallet_type: digitalWalletType !== undefined && digitalWalletType !== null ? digitalWalletType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentSelectViewOptionsEvent
 */
export var InstrumentSelectViewOptions = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken, actions = _a.actions;
    return ({
        name: "Instrument Select ViewOptions",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Select",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            actions: actions !== undefined && actions !== null ? actions.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see InstrumentSelectDigitalWalletOpenedEvent
 */
export var InstrumentSelectDigitalWalletOpened = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken, digitalWalletType = _a.digitalWalletType;
    return ({
        name: "Instrument Select DigitalWalletOpened",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Select",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            digital_wallet_type: digitalWalletType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH)
        }
    });
};
/**
 * @see InstrumentSelectDigitalWalletClosedEvent
 */
export var InstrumentSelectDigitalWalletClosed = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken, reason = _a.reason, digitalWalletType = _a.digitalWalletType;
    return ({
        name: "Instrument Select DigitalWalletClosed",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "Select",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            reason: reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH),
            digital_wallet_type: digitalWalletType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH)
        }
    });
};
/**
 * @see InstrumentViewViewLinkingOptionsEvent
 */
export var InstrumentViewViewLinkingOptions = function (_a) {
    var options = _a.options, source = _a.source;
    return ({
        name: "Instrument View ViewLinkingOptions",
        parameters: {
            cdf_entity: "Instrument",
            cdf_action: "View",
            options: options !== undefined && options !== null ? options.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
